const SubscribeNowOverlay = () => import(/* webpackPrefetch: true, webpackChunkName: "subscribe-now-overlay" */ '@/app/views/main-view/_shared/_utilities/subscribe-now-overlay/subscribe-now-overlay.vue');

export default {
  name: 'HealthDataComponent',
  components: {
    SubscribeNowOverlay
  },
  data() {
    return {
        isNotSubscribed: true
    }
  }
}